/** The three values native sends; anything else (a typo, an older or newer host's value) is ignored. */
export function parseDesktopWindowMode(value) {
    return value === 'vertical' || value === 'comfy' || value === 'window' ? value : null;
}
/** The roomy layout (the sidebar open by default, the panel's 'expanded' class): Comfy, and the resizable desktop window. */
export function isRoomyWindowMode(mode) {
    return mode !== 'vertical';
}
/**
 * The header for a host. Outside the desktop workspace nothing changes: the layout switch and ✕ as always. In the overlay
 * the widget draws the window controls itself, plus the switch to the desktop window. In the desktop window the Windows
 * title bar provides close, minimize and maximize, and the vertical/Comfy switch belongs to the overlay, so the only window
 * control left is the switch back; Esc does nothing to a standard window.
 */
export function desktopWindowChrome(workspace, windowed, nativeControls) {
    if (!workspace)
        return { minimize: false, layoutToggle: true, maximize: false, close: true, windowToggle: false, escapeCloses: true };
    if (windowed)
        return { minimize: false, layoutToggle: false, maximize: false, close: false, windowToggle: true, escapeCloses: false };
    return { minimize: true, layoutToggle: true, maximize: nativeControls, close: true, windowToggle: nativeControls, escapeCloses: true };
}
/** The header switch: the 'gyro:window-mode-request' detail shell.html turns into a native command, and its label. */
export function windowToggle(windowed) {
    return windowed
        ? { request: 'overlay', label: 'Return to overlay view' }
        : { request: 'window', label: 'Show as desktop window' };
}
//# sourceMappingURL=desktopWindowMode.js.map